package com.esoris.kmpmoout.features.product

import com.esoris.kmpmoout.domaindata.product.Product

data class ProductUiState(
    val isLoading: Boolean = false,
    val loadingMessage: String? = null,
    val errorMessage: String? = null,

    // data
    val name: String = "",

    val products: List<Product> = emptyList(),
)
